import { GoogleMap } from '@react-google-maps/api';
import { googleMapStyles } from '../util/googleMapStyles';
import React from 'react';

export const UswfGoogleMap = ({
  isGoogleApiLoaded,
  showMap,
  center,
  mapHeight,
  onGoogleMapLoad,
  onGoogleMapUnmount
}) => {
  if(!isGoogleApiLoaded)
    return null;
  
  let googleMapWrapperClass = "google-map-wrapper";
  if (showMap === "expand") {
    googleMapWrapperClass += " visible-map";
  } else if (showMap === "shrink") {
    googleMapWrapperClass += " unvisible-map";
  }
  
  return (
    <div className={googleMapWrapperClass}>
      <GoogleMap
        center={center}
        mapContainerStyle={{
          maxWidth: "90%",
          width: 500,
          height: mapHeight,
          borderRadius: "25px",
        }}
        options={{
          styles: googleMapStyles,
          mapTypeControl: false,
        }}
        zoom={15}
        onLoad={onGoogleMapLoad}
        onUnmount={onGoogleMapUnmount}
      />
    </div>
  );
}
